// ============================================================
// Kelola Produk Kasir — daftar & filter
// ============================================================

import axios from '../../config/axios.js';
import Alpine from 'alpinejs';

function createKasirProducts() {
  return {
    hydrated: false,
    loading: false,
    products: [],
    categories: [],
    createUrl: '#',
    editUrlBase: '',
    search: '',
    filterStatus: '',
    filterCategory: '',
    showCostPrice: false,

    init() {
      try {
        const raw = this.$el.getAttribute('data-config');
        if (raw) {
          const cfg = JSON.parse(raw);
          this.products = cfg.products || [];
          this.categories = cfg.categories || [];
          this.createUrl = cfg.createUrl || '#';
          this.editUrlBase = cfg.editUrlBase || '';
          this.showCostPrice = !!cfg.showCostPrice;
        }
      } catch (e) {
        console.error('kasirProducts: gagal memuat config', e);
      }
      this.hydrated = true;
    },

    editUrl(id) {
      return this.editUrlBase + '/' + id + '/edit';
    },

    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/products', {
          params: { search: this.search, status: this.filterStatus, category_id: this.filterCategory },
        });
        this.products = data.data || [];
      } catch (e) {
        window.toast(e.response?.data?.message || 'Gagal memuat produk.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async remove(p) {
      const ok = await window.confirmDialog({
        title: 'Hapus Produk?',
        message: `Hapus produk "${p.name}" beserta variannya? Tindakan ini tidak dapat dibatalkan.`,
        confirmText: 'Ya, Hapus',
        cancelText: 'Batal',
        variant: 'danger',
      });
      if (!ok) return;
      try {
        await axios.delete('/api/v1/kasir/products/' + p.id);
        window.toast('Produk dihapus.', 'success');
        await this.fetch();
      } catch (e) {
        window.toast(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },

    formatRP(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },
  };
}

Alpine.data('kasirProducts', createKasirProducts);
